/**
 * Configuration for resume info. Provides information
 * on resume fields and mapping between API names and drupal naming structure.
 */
const jobiqoResumesConfig = require('./../src/jobiqo/config/resume');
const R = require('ramda');
const { geoFixtures } = require('./fixtures');

const applicantsActive = true;
const resumeActive = true;

module.exports = R.mergeDeepRight(jobiqoResumesConfig, {
  // Insert config here. this will be deep merged with config from jobiqo. Arrays are not deep mergeable
  // so make sure to cover those with [...jobiqoCompanyConfig.public.SOME_KEY_THAT_IS_ARRAY, new_item ]
  public: {
    RESUME_FEATURE_ACTIVE: resumeActive,
    APPLICANT_FEATURE_ACTIVE: applicantsActive,
    RESUME_SEARCHES_FEATURE_ACTIVE: true,
    RESUME_CONTACT_FEATURE_ACTIVE: true,
    RECOMMENDER: {
      RESUME_DETAIL_PAGE: true,
    },
    RESUME_TOPCV_FEATURE_ACTIVE: true,
    RESUME_TOPCV_UPLOAD_CHECKED: true,
    GEO_INFO: {
      fixtures: geoFixtures,
    },
  },
});
